import { render } from "./ArrowLeft.vue?vue&type=template&id=625aeac2"
const script = {}

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__